namespace GeniuzPOS.InventoryReport {
    export class IcReport02Columns {
        static columnsKey = 'InventoryReport.IcReport02';
    }
}
